/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Logo = ({ displayLogo = "" }) => {
  const data = useStaticQuery(query)

  if (displayLogo === "onlyLogo") {
    return (
      <img src={data.logo.publicURL} />
      // <GatsbyImage
      //   image={data.logo.childImageSharp.gatsbyImageData}
      //   alt="logo"
      // />
    )
  }

  return (
    <div
    className="logo-outer"
      sx={{
        backgroundColor: "transparent",
        width: "100%",
        zIndex:"2",
        position:"relative",
        top:"-2px",
      }}
    >
      <div
        sx={{
          display: "flex",
          justifyContent: "center",
          maxWidth: "340px",
          margin: "0 auto",
        }}
      >
        <img 
        sx={{
          borderRadius:"0px !important",
        }}
        src={data.logo.publicURL}></img>
        {/* <GatsbyImage
          image={data.logo.childImageSharp.gatsbyImageData}
          alt="logo"
          imgStyle={{ objectFit: "contain" }}
        /> */}
      </div>
      <div
        sx={{

        }}
      />
    </div>
  )
}

export default Logo

const query = graphql`
  query LogoQuery {
    logo: file(name: { eq: "SIM_Hero_Logo_Banner" }) {
      name
      publicURL
      childImageSharp {
        gatsbyImageData
      }
    }
  }
`
